import { TYPES } from 'action-types/search';
import {
    ISearchs
} from './models';

interface IAction {
    readonly type: string;
    readonly response: ISearchs;
    readonly errors: any[];
}
export interface ISearchState {
    readonly isFetchSearchDataLoading: boolean;
    readonly isFetchSearchDataError: boolean;
    readonly searchPendingError: string | string[];
    response: any
}

export const defaultState: ISearchState = {
    isFetchSearchDataLoading: false,
    isFetchSearchDataError: false,
    searchPendingError: '',
    response: {
        pageNumber: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    }
};

export const reducer = (state: ISearchState = defaultState, action: IAction): ISearchState => {
    switch (action.type) {
        case TYPES.RESET_SEARCH_DATA.PENDING:
            return {
                response: defaultState.response,
                isFetchSearchDataLoading: true,
                isFetchSearchDataError: false,
                searchPendingError: ''
            };
        case TYPES.FETCH_SEARCH_DATA.PENDING:
            state.response.result = [];
            return {
                response: defaultState.response,
                isFetchSearchDataLoading: true,
                isFetchSearchDataError: false,
                searchPendingError: ''
            };
        case TYPES.FETCH_SEARCH_DATA.FULFILLED:
            const result = action.response && action.response.result ? action.response : defaultState.response;
            const response = {
                ...state,
                response: result,
                isFetchSearchDataLoading: false,
                isFetchSearchDataError: false,
                searchPendingError: ''
            };
            return response
        case TYPES.FETCH_SEARCH_DATA.REJECTED:
            return {
                ...state,
                isFetchSearchDataLoading: false,
                isFetchSearchDataError: true,
                searchPendingError: action.errors
            };
        default:
            return state;
    }
};
